module.exports = __webpack_public_path__ + "static/media/ze.8dce858e.mp3";